var metaVersion = document.querySelector("meta[name='version']");
var baseUrl = "/";
var urlArgs = "";

if (metaVersion) {
    urlArgs = "v=" + metaVersion.content;
}

require.config({
    baseUrl: baseUrl,
    waitSeconds: 30000,
    paths: {
        NumericStringFormat: "lib/ksc-numeric-string-format/bundle",
        "komplett-pubsub": "lib/komplett-pubsub/pubsub",
        "ksc-breakpoint-notifier": "lib/ksc-breakpoint-notifier/js/main",
        "ksc-ko-extenders": "lib/ksc-ko-extenders/index",
        "ksc-alert": "lib/ksc-alert/js/main",
        "ksc-alert/ViewModel": "lib/ksc-alert/js/main",
        "ksc-ubo": "lib/ksc-ubo/js/main",
        "ksc-ubo/uboService": "lib/ksc-ubo/js/main",
        knockout: "JScript/Shims/knockout-shim",
        querystring: "JScript/Shims/querystring-shim",
        dataLayer: "JScript/Shims/datalayer-shim",
    },
    urlArgs: urlArgs,
});